import React from "react";
import { HStack, VStack, Heading, Text, Button, Icon } from "@chakra-ui/react";
import useThemeColors from "../../hooks/useThemeColors";
import { IconType } from "react-icons";

interface SectionHeaderProps {
  title: string;
  subtitle?: string;
  icon?: IconType;
  buttonText?: string;
  onButtonClick?: () => void;
  buttonIcon?: IconType;
  buttonColorScheme?: string;
  mb?: number | string;
  color?: string;
  buttonVariant?: "solid" | "outline" | "ghost";
  buttonSize?: "xs" | "sm" | "md" | "lg";
  reducedColors?: boolean;
}

const SectionHeader: React.FC<SectionHeaderProps> = ({
  title,
  subtitle,
  icon,
  buttonText,
  onButtonClick,
  buttonIcon,
  buttonColorScheme,
  mb = 2,
  color,
  buttonVariant = "solid",
  buttonSize = "md",
  reducedColors = false,
}) => {
  const colors = useThemeColors();

  return (
    <HStack
      gap={6}
      justify="space-between"
      align="center"
      mb={mb}
      flexDirection={["column", "row"]}
      alignItems={["stretch", "center"]}
    >
      <HStack gap={4} align="center">
        {icon && (
          <Icon as={icon} mr={2} color={reducedColors ? colors.schoolAccent.primary + ".200" : colors.schoolAccent.icon} boxSize={6} />
        )}
        <VStack gap={0} align="start">
          <Heading size="md" color={reducedColors ? "white" : color || colors.text.primary}>
            {title}
          </Heading>
          {subtitle && (
            <Text fontSize="sm" color={reducedColors ? colors.schoolAccent.primary + ".200" : colors.text.secondary}>
              {subtitle}
            </Text>
          )}
        </VStack>
      </HStack>
      {buttonText && onButtonClick && (
        <Button
          colorPalette={buttonColorScheme || colors.schoolAccent.primary}
          variant={buttonVariant}
          size={buttonSize}
          onClick={onButtonClick}
          _hover={{ transform: "translateY(-1px)" }}
          transition="all 0.2s"
        >
          <Icon as={buttonIcon} />
          {buttonText}
        </Button>
      )}
    </HStack>
  );
};

export default SectionHeader;
